define('lib/view/PaginatedCompositeView',['require','marionette','backbone'],function (require) {

    var Marionette = require('marionette');
    var Backbone = require('backbone');

    /**
     * Paginated Composite view
     *
     * @class PaginatedCompositeView
     */
    return Marionette.CompositeView.extend({

        _page: 1,
        _onPage: 4,
        collectionEvents: {
            'sync': 'render'
        },
        ui: {
            'page': '#sb_product_pagination .sb-page',
            'nextPage': '#sb_product_pagination .sb-next',
            'prevPage': '#sb_product_pagination .sb-prev'
        },
        events: {
            'click @ui.page': 'onChangePage',
            'click @ui.nextPage': 'onNextPage',
            'click @ui.prevPage': 'onPrevPage'
        },

        /**
         * Initialisation
         */
        initialize: function () {
            if (this.getOption('page')) {
                this._page = this.getOption('page');
            }
            if (this.getOption('onPage')) {
                this._onPage = this.getOption('onPage');
            }
        },

        /**
         * On change page
         *
         * @param event
         * @return {boolean}
         */
        onChangePage: function (event) {
            this.setPage(Backbone.$(event.target).data('sb-page'));

            return false;
        },

        /**
         * On next page clicked
         */
        onNextPage: function () {
            var page = this.getPage() + 1;
            if (page > this.getPageCount()) {
                return false;
            }
            this.setPage(page);

            return false;
        },

        /**
         * On prev page clicked
         */
        onPrevPage: function () {
            var page = this.getPage() - 1;
            if (page < 1) {
                return false;
            }
            this.setPage(page);

            return false;
        },

        /**
         * Filter items that does not fit to this page
         *
         * @param model
         * @param index
         * @return {boolean}
         */
        filter: function (model, index) {
            var from = this._onPage * (this._page - 1);
            var to = from + this._onPage;

            return (index >= from && index < to);
        },

        /**
         * Return current page
         *
         * @return {number}
         */
        getPage: function () {
            return this._page;
        },

        /**
         * Set current page
         *
         * @param page
         */
        setPage: function (page) {
            this._page = page;

            this.render();

            this.triggerMethod('page:changed', page);
        },

        /**
         * Return items on page
         *
         * @return {number}
         */
        getOnPage: function () {
            return this._onPage;
        },

        /**
         * Set items on page
         *
         * @param onPage
         */
        setOnPage: function (onPage) {
            this._onPage = onPage;

            this.render();
        },

        /**
         * Return pages count
         *
         * @return {number}
         */
        getPageCount: function () {
            return Math.ceil(this.collection.length / this.getOnPage());
        },

        /**
         * Return items count
         *
         * @return {number}
         */
        getItemsCount: function () {
            return this.collection.length;
        },

        /**
         * Serialize data to template
         */
        serializeData: function () {
            var pagerData = {
                'page': this.getPage(),
                'onPage': this.getOnPage(),
                'itemsCount': this.getItemsCount(),
                'pagesCount': this.getPageCount()
            };

            return _.extend(pagerData, Marionette.CompositeView.prototype.serializeData.apply(this));
        }

    });

});
